import './Toast.css';
export var flexContainer = '_yjszxq2-3-8-0';
export var icon = '_yjszxq1-3-8-0';
export var root = '_yjszxq0-3-8-0';
export var text = '_yjszxq3-3-8-0';